import Vue from 'vue'
import Vuex from 'vuex'
import * as API from "../api/global"

import { getMenuId } from "../utils/getMenuId"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      routerList:[],
      adminInfo: {},
      menuList: []
  },
  mutations: {
      //新增tag标签
    ADD_VISITED_VIEW:(state,view)=>{
      if(state.routerList.some(v=>v.path === view.path)) return
      state.routerList.push(
          Object.assign({},view,{
            title:view.meta.title || 'no-name'
          })
      )
       console.log(state.routerList,"list")
    },
    DEL_VISITED_VIEW:(state,view)=>{
      for (const[i,v] of state.routerList.entries()){
        if(v.path==view.path){
          state.routerList.splice(i,1)
          break
        }
      }
    },
      //清空tag标签
    DEL_ALL_VISITED_VIEWS: state=>{
      const affixTags = [{name:"home",path:"/home",title:"首页"}];
      state.routerList =affixTags
    },
    //更新tag
    UPDATE_VISITED_VIEW : (state , view) => {
        for(let v of state.visitedViews){
            if(v.path === view.path){
                v= Object.assign(v, view)
                break
            }
        }
    },
    changeState(state, payload) {
        let { stateList, key, value } = payload
        if (stateList) {
        stateList.map(item => {
          state[item.key] = item.value
        })
    } else {
         state[key] = value
        }
    }
  },
  actions: {
      //添加tag标签
      addView({ dispatch},view){
       dispatch('addVisitedView',view)
     },
     addVisitedView({commit},view){
        commit('ADD_VISITED_VIEW',view)
     },
      //删除tag标签
    delView({dispatch,state},view){
        return new Promise(resolve => {
          dispatch('delVisitedView',view)
          resolve({
            visitedViews:[...state.routerList]
          })
        })
    },
    delVisitedView({commit,state},view){
        return new Promise(resolve => {
          commit('DEL_VISITED_VIEW',view)
          resolve([...state.routerList])
        })
    },
    delAllVisitedViews({commit, state }){
      return new Promise(resolve => {
          commit('DEL_ALL_VISITED_VIEWS')
          resolve([...state.visitedViews])
      })
    },
    updateVisitedView({commit},view){
       commit('UPDATE_VISITED_VIEW',view)
    },



      async getSysPonsitionMenuOperation({ state, commit, dispatch }) {
          let param = {
              i_uid:sessionStorage.getItem('userid'),
              token:sessionStorage.getItem('token'),
              app: 'masterdata',
              version: "1.0"
          };
          let res = await API.getMenuoperation(param)
          commit("changeState", { key: 'menuList', value: res.menuList || [] })
          return res
      },
      getCurrentMenuId({ state }, payload) {
          let res = getMenuId(payload.path, state.menuList)
          return res
      }
  },
  modules: {
  }
})
